/**
 * The providers' floor for a pay-over-time line, in cents. It lives here, in a
 * plain server-safe module, and NOT in the client component that renders the
 * line: a non-component value exported from a "use client" file reaches a
 * server component as a client reference, so a comparison against it is
 * silently false and the price list's footer never rendered on the server.
 * Both the client component and the server-rendered lists import this one.
 *
 * The $250 Infield Filming add-on stays below it, so it gets no pay-over-time
 * line.
 */
export const PAY_OVER_TIME_MIN_CENTS = 30_000
